import { createInlineMarkupRegistry, pillEntry } from '@/components/block-primitives';
import { contextSourceEntry } from './kinds/source';

// Its source kind resolves from React context, so this only works where a provider sits above — block
// fields. Handing it to the prose extension type-checks and leaves every citation stuck at `missing`: the
// context entry carries no `decorationKey`, so the widget never re-keys when sources land.
// Importing it also pulls the citation layer in behind `source`, down to the sources hook.
export const contextInlineMarkup = createInlineMarkupRegistry([contextSourceEntry, pillEntry]);
